export default __webpack_public_path__ + "static/media/oops.b26a7574.svg";